"use client";

import {JSX} from "react";

import Image from "next/image";

import {RawEmbedSection} from "@/shared/ui/data-display/raw-embed/raw-embed-iframe";
import {ContainerBase} from "@/shared/ui/layout/container-base";
import {VideoLoader} from "@/shared/ui/media";

import "./styles/video-banner-form.scss";

export interface VideoBannerFormProps {
    title: string;
    videoSrc?: string;
    poster?: string;
    image?: string;
    anchorId?: string;
    customCss?: string;
    formEmbed?: string;
    mediaBorderDisabled?: boolean;
    bannerHtmlSection?: string;
}

export function VideoBannerForm({
    image,
    videoSrc,
    poster,
    title,
    anchorId,
    customCss,
    formEmbed,
    mediaBorderDisabled,
    bannerHtmlSection,
}: VideoBannerFormProps): JSX.Element {
    return (
        <section className="video-banner-form" id={anchorId}>
            <div className="video-banner-form__bg">
                {image && <Image src={image} fill alt="Banner image" className="video-banner-form__bg-image" />}
            </div>
            <ContainerBase>
                <div className="video-banner-form__grid">
                    <div
                        className={` ${mediaBorderDisabled ? "video-banner-form__video-wrapper__border-disabled" : "video-banner-form__video-wrapper"}`}
                    >
                        {videoSrc ? (
                            <VideoLoader src={videoSrc} poster={poster} controls={true} showPlayButton={true} />
                        ) : (
                            <RawEmbedSection html={bannerHtmlSection} css={customCss} scopeKey={anchorId || title} />
                        )}
                    </div>

                    <div className="video-banner-form__form">
                        {formEmbed && <RawEmbedSection html={formEmbed} css={customCss} scopeKey={anchorId || title} />}
                    </div>
                </div>
            </ContainerBase>
        </section>
    );
}
